import styled from '@emotion/styled'
import { Skeleton } from '@mui/material'
import React from 'react'

import { MinMaxDiv } from '../../../../common/components/Layout/Layout'
import { useApi } from '../../../../common/hooks/useApi'
import api from '../../../../common/services/api'
import { scale } from '../../../../common/utils/scale'
import useReserveState from '../../hooks/useReserveState'
import IfLogo from '../../images/If.svg?react'
import { InsuranceAdditionalDetailsType } from '../../utils/insurance'

import CustomershipCheck from './CustomershipCheck'
import { Container } from './Shared'

const Skeletons = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${scale(2)};
  gap: ${scale(1.5)};
`

interface Props {
  onSubmitDetails(details?: InsuranceAdditionalDetailsType): void
  onBack(): void
  onContinueAsSelfPaying(): void
}

const IFForm: React.FC<React.PropsWithChildren<Props>> = ({
  onSubmitDetails,
  onBack,
  onContinueAsSelfPaying,
}) => {
  const { selectedUser } = useReserveState()

  const insurancesApiInsuranceCompanyId = 'if'
  const translationKey = 'ifForm'

  const { data: consentStatus, pending } = useApi(
    api.v1.conceptConsentStatus,
    { subjectOmUid: selectedUser.omUid },
    null,
    true
  )
  const handleSuccess = async () => {
    try {
      await api.v1.saveConceptConsent({ subjectOmUid: selectedUser.omUid })
      onSubmitDetails({ consentGiven: true })
    } catch (error) {}
  }

  if (pending) {
    return (
      <MinMaxDiv size="620px">
        <Skeletons>
          <Skeleton variant="rectangular" height="56px" />
          <Skeleton variant="rectangular" height="71px" />
          <Skeleton variant="rectangular" height="136px" />
          <Skeleton variant="rectangular" height="56px" />
        </Skeletons>
      </MinMaxDiv>
    )
  }

  if (consentStatus?.hasActiveConsent) {
    onSubmitDetails({ consentGiven: true })
    return null
  }

  return (
    <Container>
      <CustomershipCheck
        Logo={IfLogo}
        translationKey={translationKey}
        insurancesApiInsuranceCompanyId={insurancesApiInsuranceCompanyId}
        subjectOmUid={selectedUser.omUid}
        onBack={onBack}
        onSuccess={handleSuccess}
        onContinueAsSelfPaying={onContinueAsSelfPaying}
      />
    </Container>
  )
}

export default IFForm
